import { Component, Prop, Vue } from 'vue-property-decorator'
import { StrictNullable } from '@/shared/types/app.types'
import BillingCardComponent from '@/modules/billing-module/shared/components/card/billing-card.vue'
import { InvoiceReceiptStatus, InvoiceReceiptResponse } from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'

@Component({
    components: {
        BillingCardComponent
    }
})
export default class BillingModalInvoiceReceiptCard extends Vue {
    @Prop({ type: Object, required: true }) readonly invoiceReceipt!: InvoiceReceiptResponse

    get title(): string {
        return this.invoiceReceipt.label ? `${this.invoiceReceipt.label} - ${this.$tc('accounting.field.invoice')} ${this.invoiceReceipt.invoice.label}` : '-'
    }

    get statusName(): string {
        return this.invoiceReceipt.status.translatedName
    }

    get statusClass(): StrictNullable<string> {
        let statusClass = null
        const invoiceReceipt = this.invoiceReceipt
        if (invoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED) {
            return 'state-primary'
        } else if (invoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED) {
            return 'state-success'
        }
        return statusClass
    }

    get customerName(): string {
        return this.invoiceReceipt.customer?.name ?? '-'
    }

    get dateLabel(): StrictNullable<string> {
        let dateLabel = null
        const invoiceReceipt = this.invoiceReceipt
        if (invoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED) {
            return 'accounting.field.generationDate'
        } else if (invoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED) {
            return 'accounting.field.verificationDate'
        }
        return dateLabel
    }
    get dateValue(): StrictNullable<string> {
        let dateValue = null
        const invoiceReceipt = this.invoiceReceipt
        if (invoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED) {
            return this.invoiceReceipt.generationDate
        } else if (invoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED) {
            return this.invoiceReceipt.verificationDate
        }
        return dateValue
    }

    get responsibleLabel(): StrictNullable<string> {
        let responsibleLabel = null
        const invoiceReceipt = this.invoiceReceipt
        if (invoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED) {
            return 'accounting.field.generationResponsible'
        } else if (invoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED) {
            return 'accounting.field.verificationResponsible'
        }
        return responsibleLabel
    }
    get responsibleName(): StrictNullable<string> {
        let responsibleName = null
        const invoiceReceipt = this.invoiceReceipt
        if (invoiceReceipt.status.code === InvoiceReceiptStatus.GENERATED) {
            return this.invoiceReceipt.generator!.fullName
        } else if (invoiceReceipt.status.code === InvoiceReceiptStatus.VERIFIED) {
            return this.invoiceReceipt.verifier!.fullName
        }
        return responsibleName
    }

    get accountingUnitSymbol(): string {
        return this.invoiceReceipt.invoiceAccountingUnit?.symbol ?? '-'
    }
    get conceptsTotalValue(): number {
        return this.invoiceReceipt.conceptsRealTotalValue ?? 0
    }
}
